var e;(function(r){r[r.default=1]="default",r[r.groupingService=2]="groupingService"})(e||(e={}));export{e as CatalogMode};
